import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ChamadoSuporteService } from 'src/app/admihair/service/chamado-suporte.service';
import { ChamadoSuporte } from 'src/app/admihair/api/dto/chamado-suporte';
import { Table } from 'primeng/table';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';

@Component({
  selector: 'app-chamado-empresa-listar',
  templateUrl: './chamado-empresa-listar.component.html',
  styleUrls: ['./chamado-empresa-listar.component.scss']
})
export class ChamadoEmpresaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = true;

  pageChamados: Paginador<ChamadoSuporte> = {
    size: 5,
    content: [],
    number: 0,
    totalElements: 0,
    totalPages: 0
  }

  inputBusca?: string = '';
  numeroPagina: number = 0;
  tamanhoPagina: number = 10;
  linhasTabela: number = 10;
  ordenacao: string = 'dataCriacao,DESC';

  listaFiltroSolicitado: SelectItem[] = [
    { label: 'Recebido', value: 'EMPRESA' },
    { label: 'Enviado', value: 'FRANQUIA' }
  ];
  solicitadoSelecionado: string = 'FRANQUIA';

  listaStatus: SelectItem[] = [
    { label: 'TODOS', value: 'TODOS' },
    { label: 'ABERTOS', value: 'ABERTO' },
    { label: 'RECEBIDOS', value: 'RECEBIDO' },
    { label: 'EM ATENDIMENTO', value: 'EM_ATENDIMENTO' },
    { label: 'ENCERRADOS', value: 'ENCERRADO' }
  ]
  statusSelecionado: string = 'ABERTO';

  constructor(private chamadoSuporteService: ChamadoSuporteService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
  }


  carregarChamados() {
    this.loading = true;
    this.chamadoSuporteService.listarPorEmpresaId(
      this.getEmpresa().id,
      this.numeroPagina,
      this.tamanhoPagina,
      this.ordenacao,
      this.inputBusca,
      this.statusSelecionado,
      this.solicitadoSelecionado,
    ).subscribe({
      next: (data: Paginador<ChamadoSuporte>) => {
        this.pageChamados = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  onLazyLoad(event: LazyLoadEvent) {
    if (event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    this.definirOrdenacao(event.sortField, event.sortOrder);
    this.loading = true;
    this.carregarChamados();
  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    if (sortField && sortOrder) {
      const campoDeOrdenacao = sortField ? sortField : 'dataCriacao';
      const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
      this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
    } else {
      this.ordenacao = 'dataCriacao,DESC';
    }
  }

  alterarFiltro(table: Table) {
    table.clear();
  }

  buscar(table: Table, event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.numeroPagina = 0;
    table.clear();
  }

  limpar(table: Table) {
    this.inputBusca = '';
    this.statusSelecionado = 'ABERTO';
    this.solicitadoSelecionado = 'FRANQUIA';
    table.reset();
  }

}
